import {
  blueBase,
  blueLight,
  blueLighter,
  graphAmethyst,
  graphArgentinianBlue,
  graphButterscotch,
  graphCambridgeBlue,
  graphChefchaouenBlue,
  graphDodgerBlue,
  graphKhaki,
  graphLightRed,
  graphMint,
  graphMoonstone,
  graphOldRose,
  graphPacificCyan,
  graphPictonBlue,
  graphPistachio,
  graphPurple,
  graphSandyBrown,
  graphSilverLakeBlue,
  graphSunglow,
  graphTropicalIndigo,
  graphVerdigris,
  primaryBase,
  primaryLight,
  primaryLighter,
  purpleBase,
  purpleLight,
  purpleLighter,
  redBase,
  redLight,
  secondaryBase,
  secondaryLight,
  secondaryLighter,
  yellowBase,
  yellowLight,
} from '../../styles/design-tokens';

/**
 * 36 unique contrasting colors from design tokens for subgroup visualization.
 * Used for consistent color assignment across subgroups in charts and cards.
 *
 * This palette is carefully curated to provide:
 * - Maximum visual distinction between adjacent colors
 * - Good contrast against both light and dark backgrounds
 * - Accessibility-friendly color choices
 */
const SUBGROUP_COLORS = [
  // Graph colors (20 unique colors)
  graphTropicalIndigo,
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphChefchaouenBlue,
  graphCambridgeBlue,
  graphAmethyst,
  graphPacificCyan,
  graphDodgerBlue,
  graphSunglow,
  graphVerdigris,
  graphSilverLakeBlue,
  graphButterscotch,
  graphPistachio,
  graphOldRose,
  graphArgentinianBlue,
  graphKhaki,
  graphMoonstone,
  graphMint,
  graphPurple,
  // Primary colors (3)
  primaryBase,
  primaryLight,
  primaryLighter,
  // Secondary colors (3)
  secondaryBase,
  secondaryLight,
  secondaryLighter,
  // Blue colors (3)
  blueBase,
  blueLight,
  blueLighter,
  // Purple colors (3)
  purpleBase,
  purpleLight,
  purpleLighter,
  // Red colors (2)
  redBase,
  redLight,
  // Yellow colors (2)
  yellowBase,
  yellowLight,
];

export { SUBGROUP_COLORS };
